/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupquestions1Inputs */

const en_signupquestions1 = /** @type {(inputs: Signupquestions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

const de_signupquestions1 = /** @type {(inputs: Signupquestions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen`)
};

/**
* | output |
* | --- |
* | "Questions" |
*
* @param {Signupquestions1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupquestions1 = /** @type {((inputs?: Signupquestions1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupquestions1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupquestions1(inputs)
	return de_signupquestions1(inputs)
});
export { signupquestions1 as "signupQuestions" }